import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../utils';

export interface OpenDocumentOption extends Partial<GeneralInvokeOption> {
  filePath: string;
  fileType: string;
}

// 打开文件，预览文件
export function openDocument(option: OpenDocumentOption) {
  if (!option?.filePath) {
    return logErrorAndRunFail(
      APINames.Native.OPEN_DOCUMENT,
      option,
      'parameter error:parameters.filePath should be String instead of Undefined.'
    );
  }
  const validFileType: Array<string> = [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf'
  ];
  if (option.fileType && validFileType.indexOf(option.fileType) === -1) {
    return logErrorAndRunFail(
      APINames.Native.OPEN_DOCUMENT,
      option,
      'parameter error:parameter.fileType is invalid value.'
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.OPEN_DOCUMENT, option);
}
